import React from 'react';
import { Typography, Box } from '@mui/material';

const AmountDisplayTopHeader = (totalAmount) => {

  return (
    <Box display="flex" alignItems="baseline" sx={{ flexWrap: 'wrap' }}>
      <Typography variant="body2" component="span" sx={{ fontSize: '0.6em', marginRight: '4px'}}>
        RM
      </Typography>
      <Typography variant="h4" component="span" sx={{ wordWrap: 'break-all' }}>
        <b> {totalAmount}</b>
       
      </Typography>
    </Box>
  );
};

export default AmountDisplayTopHeader;
